export const UPDATE_AUTO_INTER_CARS = 'UPDATE_AUTO_INTER_CARS';
export const UPDATE_COUNTRY_PARTNERS = 'UPDATE_COUNTRY_PARTNERS';
export const UPDATE_AUTO_INTER_BRANDS = 'UPDATE_AUTO_INTER_BRANDS'
export const UPDATE_AUTO_INTER_NEWS = 'UPDATE_AUTO_INTER_NEWS'
